<script>
export default {
    name: "IconRecycle"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -0.5 20 20">
        <path fill="currentColor"
              d="M8.638 2.541a1.5 1.5 0 0 1 2.476.086l1.834 2.896-1.08-.216a1 1 0 0 0-1.188.768 1 1 0 0 0 .8 1.167l3.288.657c.599.12 1.18-.251 1.303-.833l.677-3.194a1 1 0 0 0-.786-1.175 1 1 0 0 0-1.196.755l-.191.902-1.772-2.797c-1.318-2.081-4.317-2.185-5.777-.2L6.14 2.564A1 1 0 1 0 7.75 3.749zM2.407 8.378l-.988.235a1 1 0 0 1-1.213-.726 1 1 0 0 1 .757-1.195l3.26-.776c.593-.141 1.186.208 1.332.784l.798 3.168a1 1 0 0 1-.74 1.204 1 1 0 0 1-1.224-.71l-.248-.985-1.865 2.945a1.5 1.5 0 0 0 1.267 2.303h2.18a1 1 0 1 1 0 2h-2.18c-2.759 0-4.433-3.042-2.957-5.373zM13.141 13.967a1 1 0 1 0-1.393-1.434l-2.371 2.303-.037.038a.997.997 0 0 0 0 1.502l.037.038 2.37 2.303a1 1 0 1 0 1.394-1.434l-.677-.658h3.789c2.816 0 4.48-3.158 2.886-5.48l-.981-1.43a1 1 0 1 0-1.65 1.132l.982 1.43c.683.995-.03 2.348-1.237 2.348h-3.789z"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
